import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.login', {
        url: '/login?client&code&continue&domain&redirect',
        component: 'login'
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/login/login.state.js